export default __webpack_public_path__ + "static/media/Background_00157.f7518d85.png";